var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.component},[_c('span',{class:_vm.$style.title},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('v-divider',{staticStyle:{"margin-top":"1rem"},attrs:{"dark":""}}),_c('div',{class:[
      _vm.$style['item-wrapper'],
      ( _obj = {}, _obj[_vm.$style['item-wrapper--rows']] = _vm.rows, _obj ) ]},_vm._l((_vm.shows),function(show,index){return _c('show-list-item',{key:((show.name) + "-" + index + "-show-list"),attrs:{"id":show.id,"name":show.name,"released":show.released,"image":show.posterUrl,"padding":_vm.rows}})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }